import { features } from "../data/landingData";
import Icon from "./Icons";

export default function Features() {
  return (
    <section id="features" className="section features">
      <h2 className="section-title section-title--accent">
        Trois façons dont SAFE vous protège
      </h2>
      <div className="features-grid">
        {features.map((f, i) => (
          <div key={i} className="feature-card">
            <div className="feature-icon-wrap">
              <Icon name={f.icon} />
            </div>
            <h3 className="feature-title">{f.title}</h3>
            <p className="feature-desc">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
